// @ts-check
import { objectEntries } from '@erpagroapp/common';
import { configsSettings } from './configsSettings';
import { useSettingRef } from './main';

/**
 * Resets the settings that need to be reset when the user logs out.
 * @param {object} [options]
 * @param {boolean} [options.considerResetOnLogout=true]
 * Whether to reset the settings that need to be reset when the user logs out.
 * @returns {void}
 */
export function resetLocalSettings({
  considerResetOnLogout = true,
} = {}) {
  for (const [, config] of objectEntries(configsSettings)) {
    for (const [settingName, setting] of objectEntries(config.properties)) {
      if (!considerResetOnLogout || setting.resetOnLogout) {
        const key = /** @type {import('./configsSettings').SettingsKeys} */ (settingName);
        const settingRef = useSettingRef(key);
        settingRef.value = setting.defaultValue;
      }
    }
  }
}
